// ============================================================================
// SESSION ACL SERVICE - frontend/src/services/sessionACL.ts
// API calls for session access control list management
// ============================================================================

import { api } from './api';

export interface SessionACLEntry {
  userId: string;
  email: string;
  grantedBy: string;
  grantedAt: string;
  accessLevel: 'read' | 'write';
  expiresAt?: string;
}

export interface SessionACL {
  sessionId: string;
  ownerId: string;
  ownerEmail: string;
  acl: SessionACLEntry[];
}

export interface AddToACLRequest {
  email: string;
  accessLevel: 'read' | 'write';
  expiresAt?: string;
}

/**
 * Get ACL for a session
 */
export async function getSessionACL(sessionId: string): Promise<SessionACL> {
  const response = await api.get(`/api/sessions/${sessionId}/acl`);
  return response.data;
}

/**
 * Add user to session ACL (or update existing entry)
 */
export async function addUserToACL(
  sessionId: string,
  request: AddToACLRequest
): Promise<{ success: boolean; acl: SessionACLEntry[] }> {
  const response = await api.post(`/api/sessions/${sessionId}/acl`, request);
  return response.data;
}

/**
 * Remove user from session ACL
 */
export async function removeUserFromACL(
  sessionId: string,
  userId: string
): Promise<{ success: boolean; acl: SessionACLEntry[] }> {
  const response = await api.delete(`/api/sessions/${sessionId}/acl/${userId}`);
  return response.data;
}
